export default __webpack_public_path__ + "static/media/30.5751c711.mp3";